import React, { useState } from "react";
import "../Assets/Styles/form.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";

const SegmentedFrTest = () => {
  const [formData, setFormData] = useState({
    sl: "",
    ph: "",
    hero: "",
    trackingCode: "",
    heroUrl: "",
    tileOne: "",
    tileTwo: "",
    tileThree: "",
    tileFour: "",
    tileOneUrl: "",
    tileTwoUrl: "",
    tileThreeUrl: "",
    tileFourUrl: "",
    tileOneImg: "",
    tileTwoImg: "",
    tileThreeImg: "",
    tileFourImg: "",
    cta: "",
    ctaUrl: "",
    body: "",
    hasProduct: "",
    showDiv: "No",
    inStock: false,
  });

  const [showPreview, setShowPreview] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let updatedValue = type === "checkbox" ? checked : value;

    if (name === "ph" || name === "sl") {
      updatedValue = value.replace(/\./g, "");
    }
    if (name === "trackingCode") {
      updatedValue = value.replace(/\s/g, "");
    }
    setFormData({ ...formData, [name]: updatedValue });
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];
    if (file) {
      const fileName = file.name;
      const fileUrl = URL.createObjectURL(file);
      setFormData({ ...formData, [name]: { fileName, fileUrl } });
    }
  };

  const heroFileName = formData.hero?.fileName;
  const tileoneFileName = formData.tileOneImg?.fileName;
  const tiletwoFileName = formData.tileTwoImg?.fileName;
  const tilethreeFileName = formData.tileThreeImg?.fileName;
  const tilefourFileName = formData.tileFourImg?.fileName;
  const ctaFileName = formData.cta?.fileName;

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setShowPreview(true);
    saveAsHtmlFile();
  };

  const replaceFrenchCharacters = (text) => {
    const replacements = {
      é: "&eacute;", è: "&egrave;", ê: "&ecirc;", à: "&agrave;",
      â: "&acirc;", ç: "&ccedil;", î: "&icirc;", ï: "&iuml;",
      ô: "&ocirc;", ù: "&ugrave;", û: "&ucirc;",
      É: "&Eacute;", È: "&Egrave;", Ê: "&Ecirc;", À: "&Agrave;",
      Â: "&Acirc;", Ç: "&Ccedil;", Î: "&Icirc;", Ï: "&Iuml;",
      Ô: "&Ocirc;", Ù: "&Ugrave;", Û: "&Ucirc;",
    };
    return text.replace(/[\u00C0-\u00FF]/g, (char) => replacements[char] || char);
  };

  // ─── URL Builder Logic (latest version) ───────────────────────────────────
  const buildGraingerUrl = (baseUrlRaw, campaignCode, includeStock = false) => {
    if (!baseUrlRaw || !campaignCode) return baseUrlRaw || "";

    let baseUrl = baseUrlRaw.split('#')[0].trim();

    let urlObj;
    try { urlObj = new URL(baseUrl); } catch { return baseUrlRaw; }

    let params = new URLSearchParams(urlObj.search);

    params.delete('cm_sp');
    params.delete('cm_mmc');

    let decodedQ = params.get('q') || '';

    if (!includeStock) {
      decodedQ = decodedQ.replace(/:inStockAtBranch:DC/g, '');
      decodedQ = decodedQ.replace(/:topSeller/g, '');
      decodedQ = decodedQ.trim();
    }

    let isFilterQ = decodedQ.startsWith(':');
    let isSearchQ = decodedQ !== '' && !isFilterQ;

    let isClearance = decodedQ.includes(':shopBy:clearance') ||
                      (params.get('filterValue') || '').toLowerCase() === 'clearance';

    let filterTemplate = params.get('filterTemplate') || '';
    let type = params.get('type') || '';
    let hasType = params.has('type');
    let cptype = params.get('cptype') || '';

    params.delete('filterTemplate');
    params.delete('type');
    params.delete('q');
    params.delete('filterType');
    params.delete('filterName');
    params.delete('filterValue');
    params.delete('isWildCard');
    params.delete('cptype');
    params.delete('nls');
    params.delete('uq');
    params.delete('text');
    params.delete('remove_token');
    params.delete('code');
    params.delete('isIgnrCategoryPrediction');

    const encodeQ = (val) => encodeURIComponent(val).replace(/%20/g, '+');

    let parts = [];
    parts.push('cm_mmc=' + encodeURIComponent(campaignCode));

    if (includeStock) {
      if (isSearchQ) {
        let baseQ = decodedQ + ':topSeller:inStockAtBranch:DC';
        parts.push('q=' + encodeQ(baseQ));
        parts.push('text=' + encodeQ(decodedQ));
        parts.push('remove_token=' + encodeQ(decodedQ));
        parts.push('filterType=shopBy');
        parts.push('filterName=Shop+By');
        parts.push('filterValue=DC');
        parts.push('isWildCard=false');
        if (hasType) parts.push('type=' + encodeURIComponent(type || 'category'));
        if (cptype || type) parts.push('cptype=' + encodeURIComponent(cptype || type));
      } else {
        let baseQ = decodedQ || ':topSeller';
        if (!baseQ.includes(':inStockAtBranch:DC')) {
          baseQ = baseQ + ':inStockAtBranch:DC';
        }
        parts.push('q=' + encodeQ(baseQ));
        if (filterTemplate) parts.push('filterTemplate=' + encodeURIComponent(filterTemplate));
        parts.push('filterType=shopBy');
        parts.push('filterName=Shop+By');
        parts.push('filterValue=DC');
        parts.push('isWildCard=false');
        if (hasType) parts.push('type=' + encodeURIComponent(type || 'category'));
        if (cptype) parts.push('cptype=' + encodeURIComponent(cptype));
      }
    } else if (isClearance) {
      parts.push('q=' + encodeQ(decodedQ));
      if (filterTemplate) parts.push('filterTemplate=' + encodeURIComponent(filterTemplate));
      parts.push('filterType=shopBy');
      parts.push('filterName=Shop+By');
      parts.push('filterValue=clearance');
      parts.push('isWildCard=false');
      if (hasType) parts.push('type=' + encodeURIComponent(type || 'category'));
      if (cptype) parts.push('cptype=' + encodeURIComponent(cptype));
    } else {
      if (decodedQ) parts.push('q=' + encodeQ(decodedQ));
      if (filterTemplate) parts.push('filterTemplate=' + encodeURIComponent(filterTemplate));
      if (hasType) parts.push('type=' + encodeURIComponent(type || 'category'));
      if (cptype) parts.push('cptype=' + encodeURIComponent(cptype));
    }

    params.forEach((value, key) => {
      parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    });

    return urlObj.origin + urlObj.pathname + '?' + parts.join('&');
  };
  // ──────────────────────────────────────────────────────────────────────────

  const saveAsHtmlFile = async () => {
    const { sl, ph, body, hero, trackingCode, heroUrl, tileOne, tileTwo, tileThree, tileFour, tileOneUrl, tileTwoUrl, tileThreeUrl, tileFourUrl, tileOneImg, tileTwoImg, tileThreeImg, tileFourImg, cta, ctaUrl, hasProduct, showDiv } = formData;

    const safeSl = replaceFrenchCharacters(sl);
    const safePh = replaceFrenchCharacters(ph);
    const safeBody = replaceFrenchCharacters(body);
    const safeTileOne = replaceFrenchCharacters(tileOne);
    const safeTileTwo = replaceFrenchCharacters(tileTwo);
    const safeTileThree = replaceFrenchCharacters(tileThree);
    const safeTileFour = replaceFrenchCharacters(tileFour);
    const fileName = trackingCode ? `${trackingCode.replace(/\s+/g, "_")}` : "Generated_email.html";

    // ── Build all URLs using the URL builder logic ──
    const builtHeroUrl = buildGraingerUrl(heroUrl, trackingCode, formData.inStock);
    const builtCtaUrl = buildGraingerUrl(ctaUrl, trackingCode, formData.inStock);
    const builtTileOneUrl = buildGraingerUrl(tileOneUrl, trackingCode, formData.inStock);
    const builtTileTwoUrl = buildGraingerUrl(tileTwoUrl, trackingCode, formData.inStock);
    const builtTileThreeUrl = buildGraingerUrl(tileThreeUrl, trackingCode, formData.inStock);
    const builtTileFourUrl = buildGraingerUrl(tileFourUrl, trackingCode, formData.inStock);

    const cvHtml = `
       <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml"
xmlns:v="urn:schemas-microsoft-com:vml"
xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
<title>${safeSl}</title>
<meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta name="format-detection" content="telephone=no"/>
<meta name="x-apple-disable-message-reformatting" content=""/>
<!--><!-->
	<!--[if !mso]><!-->
<link type="text/css" href="https://fonts.googleapis.com/css?family=Roboto+Condensed:300,400,700" rel="stylesheet"  />
<link type="text/css" href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet" />
<!--<![endif]-->

<style type="text/css">
a[href^="x-apple-data-detectors:"] {
    color: inherit;
    text-decoration: inherit;
}
.appleLinks a {
    color: #000000;
    text-decoration: none;
}
.appleLinksWhite a {
    color: #ffffff;
    text-decoration: none;
}
.samsungLinks a {
    color: #666666;
    text-decoration: none;
}
body {
    margin: 0 auto !important;
    padding: 0 !important;
    -webkit-text-size-adjust: 100% !important;
    -ms-text-size-adjust: 100% !important;
    -webkit-font-smoothing: antialiased !important;
}
img {
    border: 0 !important;
    outline: none !important;
}
p {
    Margin: 0px !important;
    Padding: 0px !important;
}
table {
    border-collapse: collapse;
    mso-table-lspace: 0px;
    mso-table-rspace: 0px;
}
td, a, span {
    border-collapse: collapse;
    mso-line-height-rule: exactly;
}
.ExternalClass * {
    line-height: 100%;
}
.em_defaultlink a {
    color: inherit !important;
    text-decoration: none !important;
}
span.MsoHyperlink {
    mso-style-priority: 99;
    color: inherit;
}
span.MsoHyperlinkFollowed {
    mso-style-priority: 99;
    color: inherit;
}
input {
    display: none !important;
}
/* CSS for hiding content in desktop/webmail clients */
.imghide {
    max-height: 0px;
    font-size: 0;
    display: none;
    overflow: hidden;
}

@media only screen and (min-width:481px) and (max-width:549px) {
.desk-visible {
    display: none;
}
.showmenu {
    display: block !important;
    width: auto !important;
    overflow: visible !important;
    float: none !important;
    max-height: inherit !important;
    max-width: inherit !important;
    line-height: normal !important;
    margin-top: 0px !important;
    visibility: inherit !important;
    border-bottom: 0 !important;
}
*[id]#nav_menu {
    background-color: #2a333b;
    max-height: 0;
    overflow: hidden;
    transition: max-height .25s linear;
}
*[id]#nav_handle {
    background: url("menu_icon_sprite.png") 0 0 no-repeat;
    background-size: 23px 36px !important;
    cursor: pointer;
    display: block !important;
    width: 23px !important;
    height: 18px !important;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
*[id]#em_drop:checked + div table #nav_handle {
    background: url("menu_icon_sprite.png") 0 -18px no-repeat;
}
*[id]#em_drop:checked ~ #nav_menu {
    display: block !important;
    max-height: 300px !important;
}
.em_main_table {
    width: 100% !important;
}
.em_wrapper {
    width: 100% !important;
}
.em_wrapper2 {
    width: 100% !important;
    display: block !important;
    text-align: center !important;
    line-height: 50px !important;
    font-size: 20px !important;
    border-top: 1px solid #ffffff;
}
.em_wrapper3 {
    width: 100% !important;
    display: block !important;
    text-align: center !important;
    font-size: 20px !important;
}
.em_side {
    width: 10px !important;
}
.em_hide {
    width: 100% !important;
    height: auto !important;
}
.em_img {
    width: 100% !important;
    height: auto !important;
}
.em_center {
    text-align: center !important;
}
.em_h20 {
    height: 20px !important;
    font-size: 0px !important;
    line-height: 0px !important;
}
.em_pad {
    padding-top: 20px !important;
}
.em_aside {
    padding: 0 10px !important;
}
.em_topbom {
    padding: 20px 0px !important;
}
div[class=em_hide_desktop] {
    display: table !important;
    float: none !important;
    width: 100% !important;
    overflow: visible !important;
    height: auto !important;
}
.em_f60 {
    font-size: 70px !important;
    line-height: 72px !important;
}
.em_f40 {
    font-size: 42px !important;
    line-height: 42px !important;
}
.em_h10 {
    height: 10px !important;
}
.em_h40 {
    height: 40px !important;
}
.em_h30 {
    height: 30px !important;
}
.em_br {
    display: block !important;
    padding: 0 0 5px 0 !important;
}
.em_hide1 {
    display: none !important;
}
.em_max375 {
    max-width: 375px !important;
}
}

@media screen and (max-width: 480px) {
.desk-visible {
    display: none;
}
.showmenu {
    display: block !important;
    width: auto !important;
    overflow: visible !important;
    float: none !important;
    max-height: inherit !important;
    max-width: inherit !important;
    line-height: normal !important;
    margin-top: 0px !important;
    visibility: inherit !important;
    border-bottom: 0 !important;
}
*[id]#nav_menu {
    background-color: #2a333b;
    max-height: 0;
    overflow: hidden;
    transition: max-height .25s linear;
}
*[id]#nav_handle {
    background: url("menu_icon_sprite.png") 0 0 no-repeat;
    background-size: 23px 36px !important;
    cursor: pointer;
    display: block !important;
    width: 23px !important;
    height: 18px !important;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
*[id]#em_drop:checked + div table #nav_handle {
    background: url("menu_icon_sprite.png") 0 -18px no-repeat;
}
*[id]#em_drop:checked ~ #nav_menu {
    display: block !important;
    max-height: 300px !important;
}
.em_main_table {
    width: 100% !important;
}
.em_wrapper {
    width: 100% !important;
}
.em_wrapper2 {
    width: 100% !important;
    display: block !important;
    text-align: center !important;
    line-height: 50px !important;
    border-top: 1px solid #ffffff;
    font-size: 20px !important;
}
.em_wrapper3 {
    width: 100% !important;
    display: block !important;
    text-align: center !important;
    line-height: 40px !important;
    font-size: 20px !important;
}
.em_side {
    width: 10px !important;
}
.em_hide {
    display: none !important;
}
.em_img {
    width: 100% !important;
    height: auto !important;
}
.em_center {
    text-align: center !important;
}
.em_h20 {
    height: 20px !important;
    font-size: 0px !important;
    line-height: 0px !important;
}
.em_pad {
    padding-top: 20px !important;
}
.em_aside {
    padding: 0 10px !important;
}
u + .em_body .em_full_wrap {
    width: 100% !important;
    width: 100vw !important;
}
.em_topbom {
    padding: 20px 0px !important;
}
div[class=em_hide_desktop] {
    display: table !important;
    float: none !important;
    width: 100% !important;
    overflow: visible !important;
    height: auto !important;
}
.em_f60 {
    font-size: 55px !important;
    line-height: 58px !important;
}
.em_f40 {
    font-size: 34px !important;
    line-height: 34px !important;
}
.em_h10 {
    height: 10px !important;
}
.em_h40 {
    height: 40px !important;
}
.em_h30 {
    height: 30px !important;
}
.em_br {
    display: block !important;
    padding: 0 0 5px 0 !important;
}
.em_hide1 {
    display: none !important;
}
.em_font12 {
    font-size: 10px !important;
    line-height: 14px !important;
}
.em_max375 {
    max-width: 375px !important;
}
.imghide {
    max-height: none !important;
    font-size: 12px !important;
    display: block !important;
}
*[class].width414 {
    width: 414px !important;
}
*[class].heightAuto {
    height: auto !important;
}
}

@media screen and (max-width: 414px) {
.desk-visible {
    display: none;
}
.imghide414 {
    max-height: none !important;
    font-size: 12px !important;
    display: block !important;
}
.em_hide414 {
    display: none !important;
}
.em_br414 {
    display: block !important;
    padding: 0 0 5px 0 !important;
}
.borders {
    border-left: 2px #333;
}
}
</style>
<!--[if gte mso 9]><xml>
<o:OfficeDocumentSettings>
<o:AllowPNG/>
<o:PixelsPerInch>96</o:PixelsPerInch>
</o:OfficeDocumentSettings>
</xml><![endif]-->
</head>
<body class="em_body" style="margin:0px; padding:0px;" bgcolor="#ffffff">
<table width="100%" border="0" cellspacing="0" cellpadding="0" class="em_full_wrap" bgcolor="#ffffff">
  <tr>
    <td align="center" valign="top"><table align="center" width="550" border="0" cellspacing="0" cellpadding="0" class="em_main_table" style="width:550px; table-layout:fixed;">
        <!-- A03 HEADER SECTION -->
        <tr>
          <td align="center" valign="top"><table align="center" width="550" border="0" cellspacing="0" cellpadding="0" class="em_main_table" style="width:550px; table-layout:fixed;">
              <!-- A03 HEADER SECTION -->
              <tr>
                <td align="center" valign="top"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
                    <tr>
                      <td align="center" valign="top" bgcolor="#000000" style="padding:0 10px;"><table width="530" border="0" cellspacing="0" cellpadding="0" align="center" style="width:530px;" class="em_wrapper">
                          <!-- HEADER SECTION -->
                          <tr>
                            <td  style="PADDING-BOTTOM: 22px; PADDING-TOP: 5px; PADDING-LEFT: 0px; PADDING-RIGHT: 0px" valign="top" align="center"><table cellspacing="0" cellpadding="0" align="center" border="0">
                                <tbody>
                                  <!-- PREHEADER SECTION -->
                                  <tr>
                                    <td align="center" valign="top" style="padding:4px 0;"><table border="0" cellspacing="0" cellpadding="0" align="center">
                                        <tr>
                                          <td align="center" valign="top" style="font-family: 'Arial', sans-serif; font-size:11px; line-height:14px; color:#ffffff;">${safePh}</td>
                                        </tr>
                                      </table></td>
                                  </tr>
                                  <!-- //PREHEADER SECTION -->
                                  <tr>
                                    <td align="center" valign="top" class="em_topbom" style="padding:24px 0 0 0;"><table border="0" cellspacing="0" cellpadding="0" align="center">
                                        <tr>
                                          <td align="center" valign="top"><a href="https://www.grainger.ca/fr?cm_mmc=${trackingCode}" style="text-decoration:none;"><img src="http://t.e1.acklands.grainger.com/res/img/636B14955A5D8DC77E329D8A3E628C65.gif" width="230" height="80" alt="flogo" title="flogo" border="0" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#ffffff; font-weight:bold; max-width:230px;" /></a></td>
                                        </tr>
                                      </table></td>
                                  </tr>
                                </tbody>
                              </table></td>
                          </tr>
                          <!-- //HEADER SECTION -->
                        </table></td>
                    </tr>
                    <!-- NAVIGATION MENU -->
                    <tr>
                      <td bgcolor="#2a333b" valign="top" align="center"><table class="em_wrapper" style="TABLE-LAYOUT: fixed" cellspacing="0" cellpadding="0" width="550" align="center" border="0">
                          <tbody>
                            <tr>
                              <td valign="middle" align="center"><!--[if !mso]><!-->
                                
                                <input id="em_drop2" style="OVERFLOW: hidden; WIDTH: 0px; FLOAT: left; DISPLAY: none !important; LINE-HEIGHT: 0; MAX-HEIGHT: 0px" type="checkbox"/>
                                <div class="showmenu" style="OVERFLOW: hidden; WIDTH: 0px; FLOAT: left; DISPLAY: none; LINE-HEIGHT: 0; MAX-HEIGHT: 0px">
                                  <table style="MARGIN: 0px auto" cellspacing="0" cellpadding="0" align="center" border="0">
                                    <tbody>
                                      <tr>
                                        <td height="50" valign="middle" align="center"><label id="nav_handle" for="em_drop2"></label></td>
                                        <td style="WIDTH: 10px" width="10">&nbsp;</td>
                                        <td style="FONT-SIZE: 20px; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; FONT-WEIGHT: bold; COLOR: #ffffff" height="50" valign="middle" align="center"><label for="em_drop2">MENU</label></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                
                                <!--<![endif]-->
                                
                                <div id="nav_menu2" style="MARGIN-LEFT: 0px; Z-INDEX: 50; MARGIN-RIGHT: 0px"> 
                                  <!--<![endif]--> 
                                  <!--[if gte mso 9]>
	  <table width="550" border="0" cellspacing="0" cellpadding="0" align="left" class="em_wrapper">
	  <tr>
	  <td height="50" valign="middle" align="center" width="150">
	  <![endif]--> 
                                  <a href="https://www.grainger.ca/fr/login?frwdUrlPath=/my-account/&cm_mmc=${trackingCode}" class="em_wrapper2" style="font-family: 'Roboto Condensed', 'Arial', sans-serif;font-size:14px;color:#ffffff;font-weight:bold;text-decoration:none;line-height:16px; padding-top:8px; padding-bottom: 8px; width:145px; float:left; display:inline-block; text-transform:uppercase;"><span class="em_hide">&nbsp;</span>MON <br class="desk-visible"/>
                                  COMPTE</a> 
                                  <!--[if gte mso 9]>
                  </td>
                  <td height="50" valign="middle" align="center" width="150">
                  <![endif]--> 
                                  <a href="https://www.grainger.ca/fr/catégorie/c/1?cm_mmc=${trackingCode}" class="em_wrapper2" style="font-family: 'Roboto Condensed', 'Arial', sans-serif;font-size:14px;color:#ffffff;font-weight:bold;text-decoration:none;line-height:16px; padding-top:8px; padding-bottom: 8px; width:145px; float:left; display:inline-block;">TOUS LES <br class="desk-visible"/>
                                  PRODUITS</a> 
                                  <!--[if gte mso 9]>
                  </td>
                  <td height="50" valign="middle" align="center" width="150">
                  <![endif]--> 
                                  <a href="https://www.grainger.ca/fr/login?frwdUrlPath=/my-account/orderHistory&cm_mmc=${trackingCode}" class="em_wrapper2" style="font-family: 'Roboto Condensed', 'Arial', sans-serif;font-size:14px;color:#ffffff;font-weight:bold;text-decoration:none;line-height:16px; padding-top:8px; padding-bottom: 8px; width:145px; float:left; display:inline-block;">HISTORIQUE DES COMMANDES</a> 
                                  <!--[if gte mso 9]>
                  </td>
                  <td height="50" valign="middle" align="center">
                  <![endif]--> 
                                  <a href="https://www.grainger.ca/fr/cart?from=%2Ffr%2Fcat%25C3%25A9gorie%2Fc%2F1%3Fanalytics%3Dnav%26aType%3Dbrc&cm_mmc=${trackingCode}" class="em_wrapper2" style="font-family: 'Roboto Condensed', 'Arial', sans-serif;font-size:14px;color:#ffffff;font-weight:bold;text-decoration:none;line-height:16px; padding-top:8px; padding-bottom: 8px; float:left; display:inline-block; width:100px;">PANIER D&rsquo;ACHATS<span class="em_hide">&nbsp;</span></a> 
                                  <!--[if gte mso 9]>

	  </td>
	  </tr>
	  </table>
	  <![endif]--> 
                                </div></td>
                            </tr>
                          </tbody>
                        </table></td>
                    </tr>
                    <!-- //NAVIGATION MENU -->
                  </table></td>
              </tr>
            </table></td>
        </tr>
      </table></td>
  </tr>
  <!-- //C04 SECONDARY SECTION -->
  <tr>
    <td valign="top" align="center"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper" bgcolor="#FFFFFF">
        <tbody>
          <tr>
            <td><a href="${builtHeroUrl}"><img src="${heroFileName}" alt="hero" width="550" height="330" style="font-family: 'Arial', sans-serif; font-size: 22px; width: 550px; color: #000000; display: block;" title="hero" border="0" /></a></td>
          </tr>
        </tbody>
      </table></td>
  </tr>
	 
  
	<!-- Products	-->
    ${
        hasProduct === "No"
          ? ` 
           <tr>
          <td align="center" valign="top" class="em_aside" style="padding:0 0px;"><table width="510" border="0" cellspacing="0" cellpadding="0" align="center" style="width:510px;" class="em_wrapper">
              <tr>
                <td height="25" style="height:25px;">&nbsp;</td>
              </tr>
            </table></td>
        </tr>
  <tr>
    <td><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" >
        <tbody>
          <tr>
            <td><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" >
                <tbody>
               
                  <tr>
                    <td align="center" valign="top" ><a href="${builtTileOneUrl}"><img src="${tileoneFileName}" width="100" height="100" alt="prod1" title="prod1" border="0" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:180px; "/></a></td>
<td align="center" valign="top" ><a href="${builtTileTwoUrl}" style="text-decoration:none;"><img src="${tiletwoFileName}" width="100" height="100" alt="prod2" title="prod2" border="0" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:180px; "/></a></td>
<td align="center" valign="top" ><a href="${builtTileThreeUrl}" style="text-decoration:none;"><img src="${tilethreeFileName}" width="100" height="100" alt="prod2" title="prod2" border="0" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:180px; "/></a></td>
<td align="center" valign="top" ><a href="${builtTileFourUrl}" style="text-decoration:none;"><img src="${tilefourFileName}" width="100" height="100" alt="prod2" title="prod2" border="0" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:180px; "/></a></td>
                  </tr>
                  <tr>
                    <td align="center" valign="top" class="em_defaultlink" style="font-family: 'Roboto', 'Arial', sans-serif; font-size:12px; color:#000000; line-height:13px; font-weight:normal; padding:10px 0 0 0;"><p><a href="${builtTileOneUrl}" style="text-decoration:none; color:#000000; display:block; "><font color="#000000"><strong>${safeTileOne}</strong></font></a></p></td>
<td align="center" valign="top" class="em_defaultlink" style="font-family: 'Roboto', 'Arial', sans-serif; font-size:12px; color:#000000; line-height:13px; font-weight:normal; padding:10px 0 0 0;"><p><a href="${builtTileTwoUrl}" style="text-decoration:none; color:#000000; display:block; "><font color="#000000"><strong>${safeTileTwo}</strong></font></a></p></td>
<td align="center" valign="top" class="em_defaultlink" style="font-family: 'Roboto', 'Arial', sans-serif; font-size:12px; color:#000000; line-height:13px; font-weight:normal; padding:10px 0 0 0;"><p><a href="${builtTileThreeUrl}" style="text-decoration:none; color:#000000; display:block; "><font color="#000000"><strong>${safeTileThree}</strong></font></a></p></td>
<td align="center" valign="top" class="em_defaultlink" style="font-family: 'Roboto', 'Arial', sans-serif; font-size:12px; color:#000000; line-height:13px; font-weight:normal; padding:10px 0 0 0;"><p><a href="${builtTileFourUrl}" style="text-decoration:none; color:#000000; display:block; "><font color="#000000"><strong>${safeTileFour}</strong></font></a></p></td>
                  </tr>
                  <tr>
                    <td align="center" valign="top" style="padding:20px 0 0 0;"><table width="140" border="0" cellspacing="0" cellpadding="0" align="center" style="width:140px;">
                        
                      </table></td>
<td align="center" valign="top" style="padding:20px 0 0 0;"><table width="140" border="0" cellspacing="0" cellpadding="0" align="center" style="width:140px;">
                        <tbody>
                          
                        </tbody>
                      </table></td>
<td align="center" valign="top" style="padding:20px 0 0 0;"><table width="140" border="0" cellspacing="0" cellpadding="0" align="center" style="width:140px;">
                        <tbody>
                          
                        </tbody>
                      </table></td>
<td align="center" valign="top" style="padding:20px 0 0 0;"><table width="140" border="0" cellspacing="0" cellpadding="0" align="center" style="width:140px;">
                      <tbody> 
                      </tbody>
                  </table></td>
                  </tr>
                </tbody>
              </table></td>
          </tr>
        </tbody>
      </table></td>
  </tr>
  `
            : `
  <tr>
    <td>&nbsp;</td>
  </tr>
  <tr>
    <td valign="top" align="center"><table bgcolor="#ffffff" width="550" height="2" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
        <tbody>
          <tr> </tr>
          <tr> </tr>
        </tbody>
      </table></td>
  </tr>
  <tr>
    <td align="center" valign="top"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
        <tr>
          <td align="center" valign="top" class="em_aside" style="padding:0 0px;"><table width="510" border="0" cellspacing="0" cellpadding="0" align="center" style="width:510px;" class="em_wrapper">
              <tr>
                <td align="Center" valign="top"  style="font-family: 'Arial', sans-serif; font-size:18px; color:#000000; padding:0 15px;"><p>${safeBody}</p></td>
              </tr>
              <tr> </tr>
            </table></td>
        </tr>
      </table></td>
  </tr>
  <tr>
    <td valign="top" align="center"><table bgcolor="#ffffff" width="550" height="15" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
        <tbody>
          <tr>
            <td height="15" style="height:15px;"></td>
          </tr>
</tbody>
      </table></td>
  </tr>
<tr>
    <td align="center" valign="top"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
        <tr>
          <td align="center" valign="top" class="em_aside" style="padding:0 0px;"><table width="510" border="0" cellspacing="0" cellpadding="0" align="center" style="width:510px;" class="em_wrapper">
              <tr>
                <td height="24" style="height:24px;" align="center"><a href="${builtCtaUrl}"><img src="${ctaFileName}" width="200" height="42" alt="fhero" /></a><br></td>
              </tr>
</table></td>
        </tr>
      </table></td>
  </tr>
  <tr>
    <td valign="top" align="center"><table bgcolor="#ffffff" width="550" height="15" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
        <tbody>
<tr>
            <td height="15" style="height:15px;"></td>
          </tr>
        </tbody>
      </table></td>
  </tr> `
        }
<!-- End Products	-->
  <tr>
    <td align="center" valign="top"><table align="center" width="550" border="0" cellspacing="0" cellpadding="0" class="em_main_table" style="width:550px; table-layout:fixed;">
        <!-- F01 SOCIAL SECTION -->
        <tbody>
          <tr>
            <td 
          style="PADDING-BOTTOM: 25px; PADDING-TOP: 25px; PADDING-LEFT: 10px; PADDING-RIGHT: 10px" 
          bgcolor="#2a333b" valign="top" align="center"><table cellspacing="0" cellpadding="0" align="center" border="0">
              <tbody>
                <tr>
                  <td valign="middle" align="center"><a style="TEXT-DECORATION: none" href="https://www.facebook.com/graingercanada?cm_mmc=${trackingCode}"><img 
                  style="FONT-SIZE: 16px; MAX-WIDTH: 50px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; DISPLAY: block; LINE-HEIGHT: 50px" 
                  border="0" alt="ffacebook" 
                  src="http://t.e1.acklands.grainger.com/res/img/BBD24EC070059605A9645A5DFE160806.png" 
                  width="45" height="45"/></a></td>
                  <td style="WIDTH: 20px" width="20">&nbsp;</td>
                  <td valign="middle" align="center"><a style="TEXT-DECORATION: none" href="https://www.youtube.com/graingercanada?cm_mmc=${trackingCode}"><img 
                  style="FONT-SIZE: 16px; MAX-WIDTH: 50px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; DISPLAY: block; LINE-HEIGHT: 50px" 
                  border="0" alt="fyoutube" 
                  src="http://t.e1.acklands.grainger.com/res/img/2894A2E9B556F7DB16FF117A20426EE1.png" 
                  width="45" height="45"/></a></td>
                  <td style="WIDTH: 20px" width="20">&nbsp;</td>
                  <td valign="middle" align="center"><a style="TEXT-DECORATION: none" href="https://ca.linkedin.com/company/graingercanada?cm_mmc=${trackingCode}"><img 
                  style="FONT-SIZE: 16px; MAX-WIDTH: 50px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; DISPLAY: block; LINE-HEIGHT: 50px" 
                  border="0" alt="flinkedin" 
                  src="http://t.e1.acklands.grainger.com/res/img/7A31981414EDAE346169F26E55381B00.png" 
                  width="45" height="45"/></a></td>
                </tr>
              </tbody>
            </table></td>
          </tr>
          <!-- //F01 SOCIAL SECTION -->
          <!-- F02 FOOTER SECTION -->
          <tr>
            <td align="center" valign="top" bgcolor="#000000" style="padding:0 30px;"><table width="490" border="0" cellspacing="0" cellpadding="0" align="center" style="width:490px;" class="em_wrapper">
              <tr>
                <td align="center" valign="top" class="em_defaultlink em_pad" style="font-family: 'Arial', sans-serif; font-size:12px; line-height:16px; color:#ffffff; font-weight:bold; padding:38px 0 0 0;"><a href="https://www.grainger.ca/fr/login?frwdUrlPath=/my-account/&cm_mmc=${trackingCode}" style="text-decoration:none; color:#ffffff; white-space:nowrap;"><font color="#ffffff" style="text-decoration: none;">Mon compte</font></a><span class="em_br414"></span><span class="em_hide414"> &nbsp;|&nbsp; </span><a href="https://www.grainger.ca/fr/content/contact-us?cm_mmc=${trackingCode}" style="text-decoration:none; color:#ffffff; white-space:nowrap;"><font color="#ffffff" style="text-decoration: none;">Contactez nous</font></a> &nbsp;|&nbsp; <a href="https://www.grainger.ca/fr/content/find-branch-location#?cm_mmc=${trackingCode}" style="text-decoration:none; color:#ffffff; white-space:nowrap;"><font color="#ffffff" style="text-decoration: none;">Trouver une succursale</font></a> &nbsp;|<br>
                  &nbsp; <a href="https://www.grainger.ca/fr/content/policies/privacy-policy?cm_mmc=${trackingCode}" style="text-decoration:none; color:#ffffff; white-space:nowrap;"><font color="#ffffff" style="text-decoration: none;">Politique de confidentialit&eacute;</font></a> &nbsp;|&nbsp; <a href="https://www.grainger.ca/fr/emailSignUp/unsubscribe?email=<%=recipient.email%>&cm_mmc=${trackingCode}" style="text-decoration:none; color:#ffffff; white-space:nowrap;"><font color="#ffffff" style="text-decoration: none;">D&eacute;sinscrire</font></a></td>
              </tr>
              <tr>
                <td 
                style="FONT-SIZE: 12px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; PADDING-BOTTOM: 0px; PADDING-TOP: 15px; PADDING-LEFT: 0px; LINE-HEIGHT: 16px; PADDING-RIGHT: 0px" 
                valign="top" align="left"><p><br />
                  <font color="#ffffff">Ce courriel &agrave; &eacute;t&eacute; envoy&eacute; &agrave; &lt;%= recipient.email %&gt;</font>.<br />
                  <br />
                  Pour garantir la livraison dans votre bo&icirc;te aux lettres &eacute;lectronique, ajoutez <a href="mailto:grainger@b.grainger.ca" target="_top" style="color: #ffffff !important; text-decoration:none !important;"><font color="#ffffff">grainger@b.grainger.ca</font></a> &agrave; votre carnet d&#39;adresses &eacute;lectroniques.</p>
                   ${showDiv === "Yes" ? `
                            <p>&nbsp;</p>
                  <p>*Offres valables en ligne uniquement ; aucun bon différé ne sera émis. Des quantités minimales de commande peuvent s'appliquer. La disponibilité et les quantités des produits sont parfois limitées et peuvent varier selon les régions. Connectez-vous à votre compte en ligne enregistré pour plus de renseignements.&nbsp;</p>
                    ` : ""}
                  <p>&nbsp;</p>
                  <p> <a href="https://www.grainger.ca/fr/content/contact-us?cm_mmc=${trackingCode}" style="text-decoration: underline; color: inherit !important;"><font color="#ffffff">Questions</font></a>? Notre centre de service &agrave; la client&egrave;le est l&agrave; pour vous aider &agrave; g&eacute;rer vos commandes, &agrave; mettre &agrave; jour une commande existante et &agrave; en passer de nouvelles.<br />
                    <br />
                    Acklands-Grainger Inc. "Grainger" "Grainger Canada" est un distributeur de produits MRE aux entreprises, les produits doivent donc &ecirc;tre utilis&eacute;s &agrave; des fins commerciales seulement. Nous nous r&eacute;servons le droit de restreindre la vente de produits jusqu&#39;&agrave; ce qu&#39;une v&eacute;rification commerciale soit effectu&eacute;e.<br />
                    <br />
                    Grainger Canada 123 Commerce Valley Drive East, Suite 700, Thornhill, Ontario&nbsp;L3T&nbsp;7W8</p></td>
              </tr>
              <tr>
                <td height="40" style="height:40px;">&nbsp;</td>
              </tr>
            </table></td>
          </tr>
          <!-- //F02 FOOTER SECTION -->
          <tr>
            <td class="em_hide" style="line-height:1px;min-width:550px;background-color:#ffffff;"><img alt="" src="http://t.e1.acklands.grainger.com/res/img/F2229E22CDA170C551671E5853235FE1.gif" height="1"  width="550" style="max-height:1px; min-height:1px; display:block; width:550px; min-width:550px;" border="0" /></td>
          </tr>
        </tbody>
      </table></td>
  </tr>
</table>
</body>
</html>`;

    try {
      if (window.showSaveFilePicker) {
        const handle = await window.showSaveFilePicker({
          suggestedName: fileName,
          types: [{ description: "HTML Files", accept: { "text/html": [".html"] } }],
        });
        const writable = await handle.createWritable();
        await writable.write(cvHtml);
        await writable.close();
        toast.success("File saved successfully!");
      } else {
        const blob = new Blob([cvHtml], { type: "text/html" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
        toast.success("File saved successfully!");
      }

      setFormData({
        sl: "", ph: "", trackingCode: "", hero: "", heroUrl: "",
        ctaUrl: "", body: "", tileOne: "", tileTwo: "", tileThree: "",
        tileFour: "", tileOneUrl: "", tileTwoUrl: "", tileThreeUrl: "",
        tileFourUrl: "", hasProduct: "", showDiv: "No", inStock: false,
      });

      const heroInput = document.querySelector('input[name="hero"]');
      const tileoneInput = document.querySelector('input[name="tileOneImg"]');
      const tiletwoInput = document.querySelector('input[name="tileTwoImg"]');
      const tilethreeInput = document.querySelector('input[name="tileThreeImg"]');
      const tilefourInput = document.querySelector('input[name="tileFourImg"]');
      if (heroInput) heroInput.value = "";
      if (tileoneInput) tileoneInput.value = "";
      if (tiletwoInput) tiletwoInput.value = "";
      if (tilethreeInput) tilethreeInput.value = "";
      if (tilefourInput) tilefourInput.value = "";

    } catch (error) {
      console.error("Error saving file:", error);
      toast.error("Failed to save the file!");
    }
  };

  return (
    <>
      <div className="container my-5">
        <div className="form-container">
          <h1 style={{ textAlign: "center" }}>Segmented Email (French)</h1>
          <form onSubmit={handleFormSubmit}>
            <div className="row">
              <div className="col-md-6">
                <label>Sl</label>
                <input type="text" name="sl" value={formData.sl} onChange={handleInputChange} placeholder="" required />
              </div>
              <div className="col-md-6">
                <label>ph</label>
                <input type="text" name="ph" value={formData.ph} onChange={handleInputChange} placeholder="" required />
              </div>
              <div className="col-md-12">
                <label>Tracking Code</label>
                <input type="text" name="trackingCode" value={formData.trackingCode} onChange={handleInputChange} placeholder="" required />
              </div>
              <div className="col-md-6">
                <label>Hero Banner</label>
                <input type="file" name="hero" onChange={handleFileChange} placeholder="" required />
              </div>
              <div className="col-md-6">
                <label>Hero Banner Url</label>
                <input type="text" name="heroUrl" value={formData.heroUrl} onChange={handleInputChange} placeholder="" required />
              </div>
              <div className="col-md-12">
                <label>Products OR CTA</label>
                <select name="hasProduct" value={formData.hasProduct} onChange={handleInputChange} style={{ width: "100%", marginBottom: "10px", padding: "5px" }}>
                  <option value="" hidden disabled>Select</option>
                  <option value="No">Products</option>
                  <option value="Yes">CTA</option>
                </select>
              </div>

              {formData.hasProduct === "No" && (
                <>
                  <div className="col-md-6"><label>1st Tile Title</label><input type="text" name="tileOne" value={formData.tileOne} onChange={handleInputChange} placeholder="" required /></div>
                  <div className="col-md-6"><label>1st Tile Image</label><input type="file" name="tileOneImg" onChange={handleFileChange} placeholder="1st Tile Image" required /></div>
                  <div className="col-md-12"><label>1st Tile Url</label><input type="text" name="tileOneUrl" value={formData.tileOneUrl} onChange={handleInputChange} placeholder="" required /></div>
                  <div className="col-md-6"><label>2nd Tile Title</label><input type="text" name="tileTwo" value={formData.tileTwo} onChange={handleInputChange} placeholder="" required /></div>
                  <div className="col-md-6"><label>2nd Tile Image</label><input type="file" name="tileTwoImg" onChange={handleFileChange} placeholder="" required /></div>
                  <div className="col-md-12"><label>2nd Tile Url</label><input type="text" name="tileTwoUrl" value={formData.tileTwoUrl} onChange={handleInputChange} placeholder="" required /></div>
                  <div className="col-md-6"><label>Third Tile Title</label><input type="text" name="tileThree" value={formData.tileThree} onChange={handleInputChange} placeholder="Third Tile Title" required /></div>
                  <div className="col-md-6"><label>Third Tile Image</label><input type="file" name="tileThreeImg" onChange={handleFileChange} placeholder="" required /></div>
                  <div className="col-md-12"><label>Third Tile Url</label><input type="text" name="tileThreeUrl" value={formData.tileThreeUrl} onChange={handleInputChange} placeholder="" required /></div>
                  <div className="col-md-6"><label>Fourth Tile Title</label><input type="text" name="tileFour" value={formData.tileFour} onChange={handleInputChange} placeholder="Fourth Tile Title" required /></div>
                  <div className="col-md-6"><label>Fourth Tile Image</label><input type="file" name="tileFourImg" onChange={handleFileChange} placeholder="" required /></div>
                  <div className="col-md-12"><label>Fourth Tile Url</label><input type="text" name="tileFourUrl" value={formData.tileFourUrl} onChange={handleInputChange} placeholder="" required /></div>
                </>
              )}

              {formData.hasProduct === "Yes" && (
                <>
                  <div className="col-md-12"><label>Body</label><input type="text" name="body" value={formData.body} onChange={handleInputChange} placeholder="" required /></div>
                  <div className="col-md-6"><label>CTA</label><input type="file" name="cta" onChange={handleFileChange} placeholder="" required /></div>
                  <div className="col-md-6"><label>CTA Url</label><input type="text" name="ctaUrl" value={formData.ctaUrl} onChange={handleInputChange} placeholder="" required /></div>
                </>
              )}

              <div className="col-md-6">
                <label>Offer</label>
                <div className="radio-group">
                  <label><input type="radio" name="showDiv" value="Yes" checked={formData.showDiv === "Yes"} onChange={handleInputChange} /> Yes</label>
                  <label style={{ marginLeft: "10px" }}><input type="radio" name="showDiv" value="No" checked={formData.showDiv === "No"} onChange={handleInputChange} /> No</label>
                </div>
              </div>
              <div className="col-md-6">
                <label>In-Stock Filter</label>
                <div className="radio-group">
                  <label>
                    <input type="checkbox" name="inStock" checked={formData.inStock} onChange={handleInputChange} style={{ marginRight: "8px" }} />
                    Add In-Stock Filter to URLs
                  </label>
                </div>
              </div>
            </div>

            <button type="submit" style={{ width: "100%", margin: "10px 0", padding: "10px", fontWeight: "bold", borderRadius: "4px", cursor: "pointer" }}>
              Generate Email
            </button>
          </form>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};

export default SegmentedFrTest;